import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  createTheme,
  ThemeProvider
} from "@mui/material";
import React from "react";
import styles from "./ProgressBackdrop.module.scss";
import { ProgressBackdropProps } from "./interfaces";

export const ProgressBackdrop = React.memo((props: ProgressBackdropProps) => {
  const progressTheme = createTheme({
    components: {
      MuiBackdrop: props.showSpinner
        ? {
            styleOverrides: {
              root: {
                backgroundColor: "rgba(255, 255, 255, 0.75)"
              }
            }
          }
        : {},
      MuiCircularProgress: {
        styleOverrides: {
          colorPrimary: {
            color: "rgba(235, 220, 0, 1)"
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={progressTheme}>
      <Backdrop
        style={props.style}
        className={`${props.className} ${styles.progressBackdrop}`}
        open={props.open}
        sx={props.sx}
      >
        <Box className={styles.container}>
          {(props.showSpinner ?? true) && (
            <Box className={styles.spinner}>
              <CircularProgress />
            </Box>
          )}
          <Box className={styles.message}>{props.message}</Box>
          {props.buttonCaption ? (
            <Box className={styles.buttonWrapper}>
              <Button
                className={styles.button}
                variant="contained"
                onClick={props.onButtonClick}
              >
                {props.buttonCaption}
              </Button>
            </Box>
          ) : null}
        </Box>
      </Backdrop>
    </ThemeProvider>
  );
});
